import { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Search from '@/components/calendar/Search';
import Detail from '@/components/calendar/Detail';
import EventCalendar from '@/components/calendar/EventCalendar';
import Add from '@/components/calendar/Add';
import CalendarEditPage from '@/page/calendar/edit/calendarEdit';

import { isMobile } from 'react-device-detect';
import Menu from '@/components/features/menu/Menu';
import ConjunctionCalendar from '@/components/features/conjunctionCalendar/ConjunctionCalendar';
import Faq from '@/components/features/faq/Faq';
import { EVENT_CALENDAR_URL } from '@/constants/calendar';
import useInitCalendarData from '@/hooks/calendar/useCalendarData';

const SUBROUTES = [
  { path: 'events', component: EventCalendar },
  { path: 'events/search', component: Search },
  { path: 'events/detail', component: Detail },
  { path: 'events/add', component: Add },
  { path: 'events/edit', component: CalendarEditPage },
  { path: 'conjunctions', component: ConjunctionCalendar },
  { path: 'faq', component: Faq },
];

const SpaceCalendar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  useInitCalendarData();

  useEffect(() => {
    const pathname = location.pathname;

    if (pathname === '/spacecalendar' || pathname === '/spacecalendar/') {
      navigate(EVENT_CALENDAR_URL);
    }
  }, [location.pathname, navigate]);

  return (
    <>
      {!isMobile && <Menu />}
      <SpaceCalendarPage $ismobile={isMobile}>
        <Routes>
          {SUBROUTES.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={<route.component />}
            />
          ))}
        </Routes>
      </SpaceCalendarPage>
    </>
  );
};

export default SpaceCalendar;

const SpaceCalendarPage = styled.main<{
  $ismobile: boolean;
}>`
  width: calc(100dvw - 20rem);
  height: 100dvh;

  box-sizing: border-box;
  margin-left: 20rem;
  background-color: #ffffff;

  ${({ $ismobile }) =>
    $ismobile &&
    css`
      width: 100dvw;
      height: 100dvh;

      margin-left: 0;
      padding: 0;
      padding-bottom: 55px;
    `}

  @media screen and (max-width: 700px) {
    font-size: 1.5rem;
    :nth-child(n) {
      font-size: inherit;
    }
  }
`;
